import { buildModelManager } from "../builder.js";
const DefaultSignedAcceptanceSelection = {
  __typename: true,
  id: true,
  createdAt: true,
  deletedAt: true,
  entityKind: true,
  invoiceId: true,
  signedAt: true,
  signedIp: true,
  signerDisplayName: true,
  signerEntityProfileId: true,
  signerEntityRole: true,
  signerEntityType: true,
  signerUserId: true,
  supersedesAcceptanceId: true,
  termsDocHash: true,
  termsDocId: true,
  updatedAt: true,
  verificationMethod: true,
  verificationSnapshot: true,
  workItemId: true
};
const modelApiIdentifier = "signedAcceptance";
const pluralModelApiIdentifier = "signedAcceptances";
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultSignedAcceptanceSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultSignedAcceptanceSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultSignedAcceptanceSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultSignedAcceptanceSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultSignedAcceptanceSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultSignedAcceptanceSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultSignedAcceptanceSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "restoreSignedAcceptance",
    operationReturnType: "RestoreSignedAcceptance",
    functionName: "restore",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      signedAcceptance: { required: false, type: "RestoreSignedAcceptanceInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultSignedAcceptanceSelection
  },
  {
    type: "action",
    operationName: "bulkRestoreSignedAcceptances",
    functionName: "bulkRestore",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "restore",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkRestoreSignedAcceptancesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultSignedAcceptanceSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "signedAcceptanceGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const SignedAcceptanceManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultSignedAcceptanceSelection,
  operations
);
export {
  DefaultSignedAcceptanceSelection,
  SignedAcceptanceManager
};
//# sourceMappingURL=SignedAcceptance.js.map
